export default {
  skillsTree: null,
  openQuestionsTree: null,
  openQuestionsBySpec: null,
  versions: null,
  materialsByQuestion: null,
  materialsBySkill: null,
  materialsGrades: null,
  materialsBySpec: null,
  specializations: null,
  specializationGroups: null,
  baseProfileTree: null,
  questionTooltips: null,
  questionAnswerTexts: null,
  questionScale: null,
  affectedSpecs: null,
  isLoading: false,
  isLoadingSpec: false,
  isLoadingAffectedSpecs: false,
  isLoadingGroup: false,
  isLoadingTree: false,
  isLoadingQuestionTooltips: false,
  isLoadingAnswerTexts: false,
  isLoadingVersion: false,
  isSubmitting: false,
  isTest: false,
  errors: null,
  validationErrors: null,
  errorStatusCode: 0,
};
